import {Steps} from "@app/pages/auth/Signup/type"
import {Path} from "@app/route_path"
import {
  Affiliate,
  getVerifyAccountEmail,
  useGetAffiliateList,
} from "@shortsworks/user-api";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, useModal } from "@shortsworks/ui";
import {
  FormFieldSchema,
  FormFieldType,
} from "@app/components/forms/types/schema";
import { AccountSchema } from "@app/pages/auth/Signup/accountSchema";
import { useFormWithSchema } from "@app/components/forms/hooks/useFormWithSchema";
import { useEffect } from "react";
import { CommonErrorModal } from "@app/components/modals/CommonErrorModal";
import FormContainer from "@app/components/forms/container/FormContainer";

export const AccountForm = () => {
  const { data: affiliateListData, isSuccess: isSuccessGetAffiliateList } =
    useGetAffiliateList();

  if (!isSuccessGetAffiliateList) {
    return <></>;
  }

  return <AccountFormField affiliateList={affiliateListData.data} />;
};

interface AccountFormFieldProps {
  affiliateList: Affiliate[];
}

const AccountFormField = ({ affiliateList }: AccountFormFieldProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { showModal } = useModal();

  const AccountAffiliateSchema: FormFieldSchema[] = [
    ...AccountSchema,
    {
      type: FormFieldType.Select,
      id: "affiliateId",
      label: "제휴처(선택)",
      placeholder: "제휴처를 선택해주세요.",
      defaultValue: "",
      layout: "vertical",
      options: affiliateList.map((affiliate) => {
        return {
          label: affiliate.name,
          value: affiliate.id,
        };
      }),
    },
  ];

  const { form, schemas, parseForm, setFormValues } = useFormWithSchema({
    formSchemas: AccountAffiliateSchema,
    mode: "onChange",
  });

  // restrict mode 에서 2번 실행되는 현상 확인 필요
  useEffect(() => {
    // if(!location.state?.platformType) {
    //     return showModal(CommonErrorModal, {title: "잘못된 경로 접근입니다."}).promise().then(() => {
    //         return navigate("/signup/step1");
    //     });
    // }
    setFormValues({
      userId: location.state?.userId,
    });
  }, []);

  useEffect(() => {
    function callback() {}
    window.addEventListener("popstate", callback);
    return () => window.removeEventListener("popstate", callback);
  }, []);

  const goPrevious = () => {
    return navigate([Path.SIGNUP, Steps.STEP1].join("/"), { state: { step: 1 } });
  };

  const goNext = async () => {
    const parsedForm = parseForm();
    if (!parsedForm.success) {
      return;
    }

    const { userId, password, confirmPassword, affiliateId } = parsedForm.data;

    if (password !== confirmPassword) {
      return showModal(CommonErrorModal, {
        title: "비밀번호가 일치하지 않습니다.",
      });
    }

    // 에러로 넘어가는 현상 수정 필요
    try {
      await getVerifyAccountEmail({ email: userId });
    } catch (error: any) {
      if (error.error.code === "1001") {
        return showModal(CommonErrorModal, {
          title: "이미 가입된 아이디입니다.",
        });
      }
    }

    return navigate([Path.SIGNUP, Steps.STEP3].join("/"), {
      state: {
        ...location.state,
        userId,
        password,
        affiliateId,
        path: Steps.STEP3,
      },
    });
  };

  return (
    <div>
      <h1 className="text-xl font-bold mb-4">회원 가입</h1>
      <FormContainer className="mb-8" schemas={schemas} form={form} />
      <div className="flex flex-row w-full">
        <Button
          className="w-full mr-4"
          variant="secondary"
          onClick={goPrevious}
        >
          이전
        </Button>
        <Button className="w-full" onClick={goNext}>
          다음
        </Button>
      </div>
    </div>
  );
};
